import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import IconsMixin from '@/mixins/IconsMixin';
import ProductMixin from '@/mixins/ProductMixin';
import { SelectedServiceProduct, Product, AddressDirectoryShowOmit, FieldName } from '../ProductsAndServicesModels';

@Component
export default class PhoneNumberPublishing extends Mixins(IconsMixin, ProductMixin) {
    @Prop({ type: Array, required: true})
    private products!: Product[];
    @Prop({ type: String, required: false})
    private serviceTypeId!: string;
    @Prop({ type: String, required: false})
    private serviceId!: string;
    @Prop({ type: String, required: false})
    private serviceCatId!: string;
    @Prop({ type: Boolean, required: false, default: false})
    private isFullCart!: boolean;

    private selectedValue = '';
    private directoryName = '';
    private directoryShowOrOmit = AddressDirectoryShowOmit.SHOW;
    private selectedAdditionalValue = false;
    private additionalDirectoryName = '';
    private additionalDirectoryShowOrOmit = AddressDirectoryShowOmit.SHOW;

    get productForPrice(): any {
        return this.products.filter(product => this.isAddditionaListing(product)).pop() || { totalAmount: '0.00', amount: '0.00' };
    }

    @Watch('products', {deep: true})
    productsChanged() {
        this.setValues();
    }

    created() {
        this.setValues();
    }

    setValues(){
        this.selectedValue = this.products.reduce((acc: string, product: Product) => {
            if (!acc && product.isSelected && product.catId && this.isPublishOption(product)) {
                const [directoryName, directoryShowOrOmit] = this.jsonParseFromValue(product.value);
                if (directoryName && directoryShowOrOmit) {
                    this.directoryName = directoryName.value;
                    this.directoryShowOrOmit = directoryShowOrOmit.value;
                }
                return product.catId.toString();
            }
            return acc;
        }, '');

        this.selectedAdditionalValue = this.products.reduce((acc: boolean, product: Product) => {
            if (!acc && product.isSelected && product.catId && this.isAddditionaListing(product)) {
                const [directoryName, directoryShowOrOmit] = this.jsonParseFromValue(product.value);
                this.additionalDirectoryName = directoryName.value;
                this.additionalDirectoryShowOrOmit = directoryShowOrOmit.value;
                return true;
            }
            return acc;
        }, false);
    }
    get productsList() {
        const productsWithoutPrices = this.products.filter((item)=> this.isPublishOption(item));
        const productsWithPrices =  this.products.filter((item)=> this.isAddditionaListing(item));
        return [...productsWithoutPrices, ...productsWithPrices];
    }

    get showInfoSection(): boolean {
        return this.selectedValue !== '' && this.selectedValue === "FAKE-PHONE-2";
    }

    get showAdditionalInfoSection(): boolean {
        return this.selectedValue === "FAKE-PHONE-2" && this.selectedAdditionalValue;
    }

    isPublishOption({catId}: Product) {
        return ["113B", "113R", "A113", "RB-113", "VC-113", "FAKE-PHONE-2"].includes(catId!);
    }

    isAddditionaListing({catId}: Product) {
        return ["VC-110", "RB-110", "A110"].includes(catId!);
    }

    getSelectedProduct({productId, catId: productCatId}: Product): SelectedServiceProduct {
        const {serviceTypeId, serviceId, serviceCatId} = this;
        return {serviceId, serviceTypeId, serviceCatId, productId, productCatId};
    }

    save(productToSave: Product) {
        if (productToSave.catId === 'FAKE-PHONE-2') {
            // remove all non-publish options and add publish option
            this.products.forEach(p => {
                if(!this.isAddditionaListing(p)) {
                    this.removeFromCart({...this.getSelectedProduct(p), noRefetch: true});
                }
            });
            const value = this.createValue(this.directoryName, this.directoryShowOrOmit);
            this.addToCart({ ...this.getSelectedProduct(productToSave), value });
        }
        else {
            // remove all options and add Non-publish option
            this.products.forEach(p => {
                    this.removeFromCart({...this.getSelectedProduct(p), noRefetch: true});
            });
            this.addToCart(this.getSelectedProduct(productToSave));
        }
    }

    private createValue(nameForDirectory: string, directoryShowOrOmit: AddressDirectoryShowOmit): string {
        return this.jsonStringifyValue([
        {
            field: FieldName.DIRECTORY_NAME,
            value: nameForDirectory
        },
        {
            field: FieldName.DIRECTORY_IN_ADDRESS,
            value: directoryShowOrOmit
        }
        ]);
    }

    saveAdditional(product: Product) {
        this.products.forEach(p => {
            //remove from cart so they can try readding it with different values
            if (p.catId === product.catId && p.productId === product.productId) {
                this.removeFromCart({...this.getSelectedProduct(p), noRefetch: true});
            }
        });
        if (this.selectedAdditionalValue && this.showAdditionalInfoSection) {
            const value = this.createValue(this.additionalDirectoryName, this.additionalDirectoryShowOrOmit);
            this.addToCart({...this.getSelectedProduct(product), value});
        }
    }
    }
